import React from "react";
import styleHair from './HairBoosterContent.module.css'
import OneItemBox from "../Universal/OneItemBox";
import HBloomPhoto from "../../../img/Products/HBloom.png"

const BodyfillersContent = () => {
    return (
        <>
            <div className={styleHair.globalContainer}>
                <div className={styleHair.container}>
                    <p className={styleHair.title}><b>H Bloom Booster®는</b> 피부장벽이 파괴된 피부 및 창상 부위에 적절한 두께로 발라 물리적으로 보호하며, 포함된 성분에 의해 수분을 유지하는 역할을 합니다. </p>
                    {/* <p className={styleHair.title}>H Bloom는 HA와 4가지 펩타이드의 조합을 기반으로 두피 문제를 해결하기 위한 제품입니다. <br/>
                        H Bloom 의 독특한 기술은 활성 성분과 펩타이드를 두피에 지속적으로 사용하여 두피의 활력을 되찾고 상태를 개선합니다.<br/>
                        H Bloom는 CE 인증을 받은 제품입니다. <br /> */}
                    {/* <b>NOW CE APPROVED</b>  */}
                    {/* </p> */}
                    <div className={styleHair.product}>
                        <OneItemBox photo={HBloomPhoto} name={"H Bloom Booster®"} label1={"Ingredients"}
                                    des1={"HA + Peptides for Scalp"} label2={"Packaging"} des2={"2ea x 1 mL"} label3={"Medical Devices"}/>
                    </div>
                </div>
            </div>
            {/* <p className={styleHair.export}>
                Export only *
            </p> */}
        </>
        
        
    );
};

export default BodyfillersContent;